(() => {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // respeta accesibilidad: no animar
  }

    const cards = Array.from(document.querySelectorAll('.card--featured'));
    if (!('IntersectionObserver' in window) || cards.length === 0) {
        // Fallback: activarlas inmediatamente sin observer
        cards.forEach((el, i) => {
            el.style.setProperty('--sheen-delay', `${0.12 + i * 0.13}s`);
            el.classList.add('is-visible');
        });
    return;
  }

  const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const el = entry.target;
            if (entry.isIntersecting && !el.dataset.seen) {
                // escalonado ligero por índice visual (evita las 3 a la vez)
                const index = cards.indexOf(el);
                el.style.setProperty('--sheen-delay', `${0.12 + index * 0.13}s`);
                el.classList.add('is-visible');
                //el.dataset.seen = '1'; // marca para no repetir en futuros scrolls
                // Si quieres permitir que vuelva a animarse al re-entrar, quita la línea anterior
            }
        });
  }, {
        root: null,
    rootMargin: '0px 0px -10% 0px', // dispara cuando ya está casi dentro
    threshold: 0.2
  });

  cards.forEach(el => io.observe(el));
})();